<script>
    import Layout from "../components/ui/layout.svelte";
    import { bpm_host } from "../store";
    import { onMount } from "svelte";


    $: booking_data = window.location.search;

    onMount(() => window.scrollTo(0,0));
</script>

<Layout>
    <div style="margin-top: 90px;">
        <iframe
            class="iframe"
            src={`${$bpm_host}/serviceinfo${booking_data}`}
            title="booking"
            scrolling="no"
        />
    </div>
</Layout>

<style>
    .iframe {
        width: 100%;
        margin-top: 50px;
        min-height: 750px;
        border: 0px solid gray;
    }

    @media (max-device-width: 1385px), (max-width: 1384px) {
        .iframe {
            width: 100%;
            margin-top: 50px;
            min-height: 800px;
            border: 0px solid gray;
        }
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .iframe {
            width: 100%;
            margin-top: 50px;
            min-height: 1780px;
            border: 0px solid gray;
        }
    }
</style>